import request from '../helpers/request';

const getClientDocument = async (clientId, fileName) => {
  const response = await request.get(
    '/HousingStock/client/documents',
    {
      fileName,
      clientId,
    },
    'Не удалось загрузить файл'
  );

  return response;
};

export default getClientDocument;
